<script>
import Layout from "@/router/layouts/main";
import AccountTabs from "@/components/AccountTabs";
import PasswordForm from "@/router/views/account/password";
import PasswordSecurityForm from "@/router/views/account/password-security";

// Agrupa as telas de senha de acesso e senha de segurança (rotas antigas continuam ativas)
export default {
  components: {
    Layout,
    AccountTabs,
    PasswordForm,
    PasswordSecurityForm
  },
};
</script>

<template>
  <Layout>
    <AccountTabs></AccountTabs>
    <PasswordForm :embedded="true"></PasswordForm>
    <PasswordSecurityForm :embedded="true"></PasswordSecurityForm>
  </Layout>
</template>
